<template>
    <div id="Requests">
        <b-container>
            <div id="il">
                <b-table
                        id="listTable"
                        selectable
                        :items="items"
                        :fields="fields"
                        :per-page=0
                        :current-page="curPage"
                        striped
                        head-row-variant="info"
                        @row-selected="onRowSelected"
                >
                </b-table>

                <b-pagination
                        v-model="curPage"
                        :total-rows="rows"
                        :per-page="perPage"
                        aria-controls="listTable"
                ></b-pagination>

            </div>

        </b-container>

        <b-container fluid class="footer text-center">
            <span class="tblName">{{ tblName }}</span>
        </b-container>
        <b-container fluid class="footer text-center"> &nbsp;&nbsp;&nbsp;
            <b-form-radio-group id="radio-group-2" v-model="selected" name="radio-sub-component">
                <a v-b-popover.hover.top="this.$t('SHOW')" title="" class="shBt">
                    <b-form-radio value="show"><font-awesome-icon icon="eye" size="lg" :style="{ color: 'white' }" /></b-form-radio>
                </a>
                <a v-b-popover.hover.top="this.$t('PUBLISH')" title="">
                    <b-form-radio value="publish"><font-awesome-icon icon="users" size="lg" :style="{ color: 'white' }" /></b-form-radio>
                </a>
                <a v-b-popover.hover.top="this.$t('DELETE')" title="" class="shBt">
                    <b-form-radio value="delete"><font-awesome-icon icon="trash-alt" size="lg" :style="{ color: 'white' }" /></b-form-radio>
                </a>
            </b-form-radio-group>
        </b-container>

        <Publish
                v-on:reloadList="reloadList"
                v-bind:userName="userName"
                v-bind:itemName="itemName"
                v-bind:onlyCommon="onlyCommon"
                :itemType="type"
                :key="myKey"
                v-if="action==='publish'"
        />

    </div>

</template>

<script>
import { BContainer, BTable, BPagination, BFormRadio, BFormRadioGroup } from 'bootstrap-vue';
import Publish from "./Publish.vue";

export default {
  name: 'Requests',
  components: {
    Publish,
    BContainer, BTable, BPagination, BFormRadio, BFormRadioGroup
  },
  data: function() {
    return {
        fields: [
          {
            key: 'userName',
            label: this.$t('USER'),
            sortable: true
          },
          {
            key: 'itemName',
            label: 'itemName',
            sortable: false
          },
          {
            key: 'userNameForCmnt',
            label: 'Commented user',
            sortable: true
          },
          {
            key: 'itemNameForCmnt',
            label: 'Commented Item',
            sortable: false
          },
          {
            key: 'itemType',
            label: 'itemType',
            sortable: false
          },
          {
            key: 'common',
            label: 'Common',
            sortable: false
          },
          {
            key: 'intLoc',
            label: 'intLoc',
            sortable: false
          }
        ],
        userName: '',
        itemName: '',
        items: [{}],
        tblName: '',
        listLoc: this.$i18n.locale,
        item: {},
        type: '',
        itemType: '',
        selected: 'show',
        myKey: 0,
        action: '',
        perPage: 10,
        curPage: 1,
        curLang: '',
        listLength: 1,
        onlyCommon: false
    }
  },
  mounted() {
    if(this.$store.state.curUserName!='admin') this.$showErr(this.$t('TMOUT'), 401);
    this.getReqs();
  },
  methods: {
    reloadList() {
        this.action='';
        this.getReqs();
        //this.myKey++;
    },
    async getReqs() {
        try {
            const response = await this.$http.get('getReqs', {});
            this.items = response.data;
            if(this.items.length == 0) {
                this.$showMsg(this.$t('EMPTY_LIST'));
                this.$router.go(-2);
            }
        }
        catch(error) {
            this.$showErr(error.response.data, error.response.status);
        }
    },
    async onRowSelected(items) {
        this.item = items[0];
        if(typeof this.item === 'undefined') return;
        this.userName = this.item.userName,
        this.itemName = this.item.itemName,
        this.type = this.item.itemType[0]==='p' ? 'places' : this.item.itemType[0]==='t' ? 'trips' : 'outings';
        if(this.item.itemType[0]==='o') this.onlyCommon = true;
        if(this.selected==='show') {
            if(this.item.itemType[0]==='p') {
                this.$router.push({
                    path: '/Place/'+this.$addEncHyp(this.item.itemName)+'/'+this.$addEncHyp(this.item.userName)
                })
            }
            else if(this.item.itemType[0]==='t') {
                this.$router.push({
                    path: '/Tour/'+this.$addEncHyp(this.item.itemName)+'/'+this.$addEncHyp(this.item.userName)
                })
            }
            else {
                this.$router.push({
                    path: '/Outing/'+this.$addEncHyp(this.item.itemName)+'/'+this.$addEncHyp(this.item.userName)
                })
            }
        }
        else if(this.selected==='publish') {
            if(this.item.itemType[1]==='-') this.action='publish';
            else {
               try {
                    const response = await this.$http.get('/publishCmnt', {
                        params: {
                            userName: this.item.userName,
                            itemName: this.item.itemName,
                            tripName: this.item.itemName,
                            userNameForCmnt: this.item.userNameForCmnt,
                            itemNameForCmnt: this.item.itemNameForCmnt,
                            itemTypeForCmnt: this.item.itemType,
                            lang: this.$i18n.locale
                        }
                    });
                    this.$showMsg(response.data);
                    this.getReqs();
                }
                catch(error) {
                    if(typeof error.response === 'undefined') this.$serveErr('Requests: PublishCmnt() '+error.message);
                    this.$showErr(error.response.data, error.response.status);
                }
            }
        }
        else if(this.selected==='delete') {
            try {
                await this.$http.get('delPubReq', {
                    params: {
                        userName: this.item.userName,
                        itemName: this.item.itemName,
                        itemType: this.item.itemType
                    }
                });
                this.$showMsg(this.$t('DONE'));
                this.getReqs();
            }
            catch(error) {
                this.$showErr(error.response.data, error.response.status);
            }
        }
    }
  },
  watch: {
      curPage: function(value) {
        this.getReqs(value);
      },

      curLang: function() {
        //alert(this.$i18n.locale);
      }
  },
  computed: {
    rows() {
        return this.listLength;
    }
  }
}

</script>

<style>
    #rg{
        color: white;
    }
    .tblName{
        color: white;
    }
</style>
